import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

/**
 * Single, consistent empty-state treatment. Replaces the ~20 ad-hoc
 * ad hoc `<p className="text-xs text-muted-foreground">No … yet.</p>` variants.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
  compact = false,
}: {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  /** Left-aligned inline treatment for dense panels; default is centered. */
  compact?: boolean;
}) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        "flex flex-col rounded-lg border border-dashed border-border/70 bg-muted/20 text-muted-foreground",
        compact
          ? "items-start gap-1 px-3 py-3 text-left"
          : "items-center gap-2 px-4 py-8 text-center",
        className
      )}
    >
      {icon ? <div className="text-muted-foreground/70 [&_svg]:size-6">{icon}</div> : null}
      <p className={cn("font-semibold text-foreground", compact ? "text-[0.8125rem]" : "text-sm")}>
        {title}
      </p>
      {description ? (
        <p className={cn("max-w-sm text-[0.8125rem] leading-relaxed", compact ? "" : "mx-auto")}>
          {description}
        </p>
      ) : null}
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  );
}
